import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

export interface PreProcessingMetric {
  label: string;
  value: number;
}

export interface PreProcessingMetrics {
  extensionByCount: PreProcessingMetric[];
  extensionBySize: PreProcessingMetric[];
  typeByCount: PreProcessingMetric[];
  typeBySize: PreProcessingMetric[];
  projectSourceSize: number;
  projectOutputSize: number;
}

export function usePreProcessingMetrics(projectId: string) {
  return useQuery<PreProcessingMetrics>({
    queryKey: ['preProcessingMetrics', projectId],
    queryFn: () => api.get<PreProcessingMetrics>(`/project/${projectId}/preprocessingmetrics`),
    enabled: !!projectId,
  });
}
